/**
 * Checkout Info Box - Dynamic Price Updates
 * ==========================================
 * 
 * Listens to cart updates and refreshes the monthly price display
 * in checkout info boxes. This script is loaded persistently in theme.liquid
 * so it survives DOM replacements when cart sections are re-rendered.
 */

(function() {
  'use strict';

  // Wait for pubsub to be available
  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      // Retry after a short delay if pubsub isn't ready
      setTimeout(init, 100);
      return;
    }

    // Subscribe to cart updates - this subscription persists across DOM changes
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
  }

  function handleCartUpdate(event) {
    const cartData = event.cartData;
    if (!cartData || typeof cartData.total_price === 'undefined') return;

    const totalPrice = cartData.total_price; // in cents
    updateAllCheckoutInfoBoxes(totalPrice);
  }

  function updateAllCheckoutInfoBoxes(totalPriceCents) {
    const infoBoxes = document.querySelectorAll('[data-checkout-info-box]');
    
    infoBoxes.forEach(box => {
      const months = parseInt(box.dataset.months, 10) || 36;
      const monthlyPriceCents = Math.round(totalPriceCents / months);
      const formattedPrice = formatMoney(monthlyPriceCents);

      // Update the bold monthly price element
      const priceEl = box.querySelector('[data-monthly-price]');
      if (priceEl) {
        priceEl.textContent = formattedPrice;
      }

      // Update text with {monthly_price} placeholder replaced
      const textEl = box.querySelector('[data-info-text]');
      const textTemplate = box.dataset.textTemplate;
      
      if (textEl && textTemplate) {
        const updatedText = textTemplate.replace('{monthly_price}', formattedPrice);
        const isCompact = box.dataset.compact === 'true';
        
        if (isCompact) {
          textEl.textContent = updatedText;
        } else {
          // Preserve line breaks in non-compact mode
          textEl.innerHTML = updatedText.replace(/\n/g, '<br>');
        }
      }
    });
  }

  /**
   * Format cents to Norwegian currency format
   * @param {number} cents - Amount in cents (øre)
   * @returns {string} Formatted price string like "1 234 kr"
   */
  function formatMoney(cents) {
    const amount = cents / 100;
    return new Intl.NumberFormat('nb-NO', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(amount) + ' kr';
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
